import { Injectable, OnDestroy } from '@angular/core';
import { COMPARISON_OPERATOR, TaskStatus } from '@common';
import { TaskManagerService } from '@common/services/task-manager.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject, Subject, concatMap, timer } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';

const POLLING_INTERVAL = 60000;
const INITIAL_DELAY = 2000;

@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class FailedTaskPollingService implements OnDestroy {
  private failedTaskSubject = new BehaviorSubject<number | null>(null);
  private destroy$ = new Subject<void>();

  get failedTask$() {
    return this.failedTaskSubject.asObservable();
  }

  constructor(private taskManagerService: TaskManagerService) {}

  startPolling(): void {
    this.stopPolling();

    timer(INITIAL_DELAY, POLLING_INTERVAL)
      .pipe(
        takeUntil(this.destroy$),
        concatMap(() =>
          this.taskManagerService
            .getQueryTasks({ filter: `State ${COMPARISON_OPERATOR.eq} '${TaskStatus.Failed}'`, pageSize: 0 })
            .pipe(catchError(() => [{ count: 0, data: [] }]))
        ),
        untilDestroyed(this)
      )
      .subscribe(({ count }) => this.failedTaskSubject.next(count));
  }

  stopPolling(): void {
    this.destroy$.next();
  }

  ngOnDestroy(): void {
    this.stopPolling();
    this.destroy$.complete();
  }
}
